<template>
	<div class="userinfor">
		<p class="txt_align"><span class="gray"> {{ getUserInfor}}</span>
			&nbsp;&nbsp;&nbsp;&nbsp;
			<span class="red">{{protectLogin}}</span>
		</p>
	</div>

</template>

<script>
	export default {
		name: 'userinfor',
		data() {
			return {
				second: 0,
				minute: 60
			}
		},
		created() {

			let that = this;
			let protect = setInterval(function() {
				if (that.second == 0) {
					if (that.minute == 0) {
						clearInterval(protect);
						that.$router.replace('/login');
					} else {
						that.minute--;
						that.second = 59;
					}
				} else
					that.second--;
			}, 1000);


		},

		computed: {
			protectLogin() {
				return '登录有效时间:' + (100 + this.minute).toString().substr(1) + '分:' + (100 + this.second).toString().substr(
					1) + '秒';
			},
			getUserInfor() {
				let str = '欢迎您: '+ this.$store.state.user.areaName + this.$store.state.user.ShopName + ' ' + this.$store.state.user.UserName;
				switch (this.$store.state.user.UserType) {
					case 0:
						str = '欢迎您:系统管理员 ' + this.$store.state.user.UserName;
						break;
					case 1:
						str = str + ' ' + '店长 ';
						break;
					case 2:
						str = str + ' ' + '店员 ';
						break;
					case 3:
						str = str + ' ' + '派送员 ';
						break;
				}

				str += '  登录店铺:' + this.$store.state.shopName;
				return str;
			}


		}
	}
</script>

<style>
	.userinfor {
		position: fixed;
		bottom: 0px;
		height: 2rem;
		line-height: 2rem;
		background-color: #E0FFFF;
		box-shadow: 0 0 10px rgba(203, 203, 203, 1.0);
		width: 100%;
		left: 0px;
	}

	@media all and (max-width:600px) {
		.txt_align {
			text-align: center;
		}
	}

	@media all and (min-width:600px) {
		.txt_align {
			padding-left: 2rem;
			text-align: left;
		}
	}
</style>
